import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
const { useState, useEffect, useRef } = React;
import { Paper, Typography } from '@mui/material';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 900,
    height: 600,
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 24,
    p: 4,
    color: 'black',
    'overflowY': 'scroll'
};
const TerminosYCondicionesComponent = (props) => {


    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    const formato = props.formato
    React.useEffect(() => {
        if (props.terminosYCondiciones) {
            setTerminosYCondiciones(props.terminosYCondiciones)
        }
    }, [props.terminosYCondiciones])

    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black" }}>
                            {/* {bodyModal}  */}
                            <div align="justify" style={{ color: "black" }}>
                                <label htmlFor="floatingInput"><h5><strong>EL SOCIO Y/O CLIENTE DECLARA BAJO PROTESTA DE DECIR VERDAD:</strong></h5></label>
                                <ol type="a">
                                    <li>Que los datos contenidos en la presente solicitud son ciertos y,</li>
                                    <li>Que ha leído y comprendido el contenido completo de los
                                        documentos: "Manual básico para inscripción y certificación ante COMERCAM (DC-02)", "Descripción
                                        de la información comercial (DC-07)", "Esquema de evaluación de la conformidad (DC-01)",
                                        "Uso adecuado del sello de certificación, marca e imagen corporativa del COMERCAM (DC-06)",
                                        "Procedimiento de producto certificado (P-PC)" vigentes, la ley de Infraestructura de la Calidad
                                        (LIC) artículo 56 fracción I, II y III, artículo 60 fracción I, III, IV y la "NOM-070-SCFI-2016,
                                        Bebidas Alcohólicas-Mezcal Especificaciones", vigente.</li>
                                </ol>
                                <label htmlFor="floatingInput"><h5><strong>LA EMPRESA A TRAVÉS DE SU REPRESENTANTE LEGAL Y AUTORIZADO SE COMPROMETE A CUMPLIR CON:</strong></h5></label>

                                <ol align="justify" type="a">

                                    <li>La Norma Oficial Mexicana  NOM-070-SCFI-2016 “Bebidas Alcohólicas-Mezcal Especificaciones”,
                                        en vigor y los Criterios Autorizados por la Dirección General de Normas (DGN) </li>
                                    <li>Lo establecido en  el "Esquema de evaluación de la conformidad (DC-01)", "Uso adecuado de la contraseña oficial NOM
                                        (DC-05)",  "Uso adecuado del sello de certificación, marca e imagen corporativa del COMERCAM (DC-06)", "Procedimiento
                                        de producto certificado (P-PC)".</li>
                                    <li>Cubrir las tarifas correspondientes al servicio solicitado y los gastos por  concepto de viáticos de los inspectores
                                        asignados para el proceso.</li>
                                </ol>

                                {/* <p>
                                    <b>CONSIDERACIONES:</b>Este formato es de distribución gratuita. Se autoriza su libre reproducción, siempre y cuando éste no sea
                                    alterado y sea presentado impreso en una hoja de papel blanco, tamaño carta, completamente requisitada, firmada y rubricada
                                    por el representante autorizado o legal de forma autógrafa.
                                </p> */}
                            </div>
                            {
                                formato === 'fc_09' || formato === 'fc_33' || formato === 'fc_30' || formato === 'fc_31' || formato === 'fc_35'
                                    || formato === 'fc_08' || formato === 'fc_40' || formato === 'fc_34' || formato === 'fc_41' || formato === 'fc_36' ?
                                    (
                                        <div>
                                            <label className="form-label"><b>CONSIDERACIONES PARA LA ACEPTACIÓN DE LA SOLICITUD:</b></label>
                                            <br />
                                            <ul type="a" align="justify">

                                                <li>Los clientes que ya obtuvieron la autorización de las botellas/etiquetas/embalaje y/o
                                                    publicidad por escrito por este Organismo de Certificación, necesitarán volverlos a
                                                    presentar solamente en caso de que hayan realizado alguna modificación a alguno de los
                                                    elementos antes descritos.</li>
                                                <li>El COMERCAM podrá cancelar los servicios de certificación si el cliente no cuenta con
                                                    los insumos necesarios para realizar la actividad, por lo que en caso de cancelación,
                                                    deberá ingresar nuevamente su solicitud.</li>
                                                <li>No se le dará trámite a la presente solicitud en caso de faltar cualquiera de los anexos.</li>
                                                <li>La fecha propuesta para la actividad será considerada si el ingreso de la solicitud se
                                                    registra con 10 días hábiles de anticipación a la fecha propuesta, también  podrá
                                                    considerarse la fecha propuesta si la solicitud se hace hasta con 2 días de anticipación
                                                    siempre y cuando, la Unidad de Inspección cuente con personal disponible en el área donde
                                                    se ubica la empresa que solicita el servicio.</li>
                                                <li>La vigencia de la presente solicitud será de 30 días a partir de la fecha propuesta para
                                                    la actividad descrita en esta solicitud, pasada su vigencia y no se haya atendido el servicio
                                                    por causas imputadas al cliente, será cancelada y deberá de ingresarla nuevamente.</li>
                                                <li>El envío de esta solicitud implica la aceptación del Contrato de prestación de servicios (vigente).</li>
                                            </ul>

                                        </div>
                                    ) : ''
                            }
                            {
                                formato === 'fc_09' || formato === 'fc_33' || formato === 'fc_31' || formato === 'fc_35' || formato === 'fc_08'
                                    || formato === 'fc_40' || formato === 'fc_34' || formato === 'fc_41' ?
                                    (
                                        <div align="justify">
                                            <b>La empresa da por enterada que:</b>
                                            <i> la Unidad de Inspeccion (UI) establecera una inspeccion de cumplimiento con la NOM permanente
                                                a sus instalaciones una vez que el certificado NOM sea emitido.
                                            </i>
                                            <p>Esta inspección tiene por objetivo comprobar que el producto siga cumpliendo con la NOM-070-SCFI-2016
                                                durante la vigencia del Certificado, por lo que la empresa deberá dar las facilidades necesarias al
                                                personal para realizar esta actividad, de lo contrario se aplicarán las sanciones descritas en el
                                                "Catálogo de Medidas Correctivas".</p>

                                        </div>
                                    ) : ''
                            }
                            {formato === 'fc_36' ?
                                (
                                    <div align="justify">
                                        <i> <b>
                                            Bajo protesta de decir verdad, manifiesto que los datos asentados en esta solicitud
                                            son ciertos y que autorizo al COMERCAM a verificarlos a su entera satisfacción,
                                            así mismo me comprometo a notificar al Consejo Mexicano Regulador de la Calidad del
                                            Mezcal, A.C., cualquier modificación que se realice a los datos que estoy proporcionando
                                            dentro de los 5 días hábiles posteriores a que esta suceda.
                                        </b>
                                        </i>

                                    </div>
                                ) : ''
                            }


                            <center><strong>¿Desea aceptar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-dark' onClick={() => {
                                switch (accion) {
                                    case 'botonTerminosYCondiciones':
                                        botonAceptarTerminosYCondicionesModal()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>ACEPTAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    const botonTerminosYCondiciones = async () => {
        handleOpenModal({
            title: `Términos y condiciones`,
            body: `EL CLIENTE DECLARA BAJO PROTESTA DE DECIR VERDAD`,
            accion: 'botonTerminosYCondiciones'
        })
    }
    const botonAceptarTerminosYCondiciones = async (target) => {
        if (formato === 'fc_09') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_09', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_09', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_33') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_33', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_33', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_01') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_01', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_01', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_30') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_30', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_30', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_31') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_31', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_31', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_35') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_35', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_35', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_08') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_08', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_08', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_40') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_40', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_40', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_34') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_34', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_34', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_41') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_41', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_41', { terminosYCondiciones: false })
            }
        }
        if (formato === 'fc_36') {
            if (target.checked) {
                setTerminosYCondiciones(true)
                props.history.push('/fc_36', { terminosYCondiciones: true })
            } else {
                setTerminosYCondiciones(false)
                props.history.push('/fc_36', { terminosYCondiciones: false })
            }
        }
    }
    const botonAceptarTerminosYCondicionesModal = async () => {
        if (formato === 'fc_09') {
            props.history.push('/fc_09', { terminosYCondiciones: true })
        }
        if (formato === 'fc_33') {
            props.history.push('/fc_33', { terminosYCondiciones: true })
        }
        if (formato === 'fc_01') {
            props.history.push('/fc_01', { terminosYCondiciones: true })
        }
        if (formato === 'fc_30') {
            props.history.push('/fc_30', { terminosYCondiciones: true })
        }
        if (formato === 'fc_35') {
            props.history.push('/fc_35', { terminosYCondiciones: true })
        }
        if (formato === 'fc_08') {
            props.history.push('/fc_08', { terminosYCondiciones: true })
        }
        if (formato === 'fc_40') {
            props.history.push('/fc_40', { terminosYCondiciones: true })
        }
        if (formato === 'fc_34') {
            props.history.push('/fc_34', { terminosYCondiciones: true })
        }
        if (formato === 'fc_41') {
            props.history.push('/fc_41', { terminosYCondiciones: true })
        }
        if (formato === 'fc_36') {
            props.history.push('/fc_36', { terminosYCondiciones: true })
        }

        setTerminosYCondiciones(true)
        handleCloseModal()
    }
    return (
        <Fragment>
            <div className='col-md-12 text-center'>
                <input className={`form-check-input me-3 escalar `} type="checkbox"
                    onChange={e => botonAceptarTerminosYCondiciones(e.target)}
                    checked={terminosYCondiciones}
                />Acepto los <a href='#' onClick={e => botonTerminosYCondiciones()}>Términos y condiciones</a>
            </div>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(TerminosYCondicionesComponent)
